import { apiClient } from './client';

export interface QuoteLineItem {
  description: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  category?: string;
}

export interface QuoteAnalysisResult {
  vendorName: string | null;
  vendorPhone: string | null;
  vendorEmail: string | null;
  lineItems: QuoteLineItem[];
  totalAmount: number | null;
  paymentTerms: string | null;
  dueDate: string | null;
  confidence: number;
  rawText: string | null;
}

/** A file just uploaded through `getQuoteImportUploadUrl`, to be read. */
export interface AnalyzeQuoteRequest {
  eventId: string;
  s3Key: string;
  fileName: string;
  mimeType: string;
}

/** Where to upload a file to be read — under the caller's own folder. */
export async function getQuoteImportUploadUrl(data: {
  fileName: string;
  mimeType: string;
}): Promise<{ uploadUrl: string; s3Key: string }> {
  const { data: result } = await apiClient.post<{ uploadUrl: string; s3Key: string }>(
    '/quote-import/upload-url',
    data,
  );
  return result;
}

export interface AnalyzeQuoteResponse {
  documentId: string;
  analysis: QuoteAnalysisResult;
}

export interface QuoteImportItem {
  description: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  accepted: boolean;
  vendorCategoryId?: string;
  statusId?: string;
  category?: string;
}

export interface QuoteImportConfirmRequest {
  eventId: string;
  documentId: string;
  vendorId?: string;
  vendorName?: string;
  items: QuoteImportItem[];
}

/** Read a file just uploaded, or a document already on file (a vendor's upload). */
export async function analyzeQuote(
  data: AnalyzeQuoteRequest | { eventId: string; documentId: string },
): Promise<AnalyzeQuoteResponse> {
  const { data: result } = await apiClient.post<AnalyzeQuoteResponse>(
    '/quote-import/analyze',
    data,
  );
  return result;
}

export async function confirmQuoteImport(data: QuoteImportConfirmRequest): Promise<unknown[]> {
  const { data: result } = await apiClient.post<unknown[]>('/quote-import/confirm', data);
  return result;
}
